import { render, staticRenderFns } from "./LobbyScreen.vue?vue&type=template&id=6d2fb4a4&scoped=true"
import script from "./LobbyScreen.vue?vue&type=script&lang=js"
export * from "./LobbyScreen.vue?vue&type=script&lang=js"
import style0 from "./LobbyScreen.vue?vue&type=style&index=0&id=6d2fb4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2fb4a4",
  null
  
)

export default component.exports